import { render, staticRenderFns } from "./AutomaticInlineExposure.vue?vue&type=template&id=38504e9b&scoped=true&"
import script from "./AutomaticInlineExposure.vue?vue&type=script&lang=js&"
export * from "./AutomaticInlineExposure.vue?vue&type=script&lang=js&"
import style0 from "./AutomaticInlineExposure.vue?vue&type=style&index=0&id=38504e9b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38504e9b",
  null
  
)

export default component.exports